exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-send-button[data-v-02f40a0e]{width:80px}", ""]);

// exports
